import { Config } from '../../src/types';

export default {
  store: {
    state: {
      constants: {
        PAY_FREQUENCIES: [{
          value: 12,
          text: 'Monthly',
          single: 'monthly',
        }, {
          value: 1,
          text: 'Annually',
          single: 'annual',
        }],
      },
      copy: {
        name: 'LBG',
        inputs: {
          income: {
            label: 'Your annual salary before tax',
          },
        },
        outputs: {
          employer: 'The Group contributes',
        },
        legend: {
          employer: `The Group's contributions`,
        },
        tooltips: {
          salaryInput: 'To work out how much your contributions cost you, the calculator automatically uses your basic pay at 30 June 2019. You can change this by typing a different amount in the input box.',
          annualMonthly: 'The calculator shows you  how much you pay based on monthly contributions. You can change this to an annual amount using the drop-down menu.',
        },
      },
      assumptions: {
        employerMatch: {
          101: {
            employee: [0.03, 0.04, 0.05],
            employer: [0.08, 0.1, 0.13],
          },
        },
      },
    },
  },

  hooks: {
  //   beforeInitialise(vm, store, router) {},
  //   afterInitialise(vm, store, router) {},
  },
} as Config;
